"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupActivityClose = groupActivityClose;
exports.groupActivityCount = groupActivityCount;
exports.groupActivityInfo = groupActivityInfo;
exports.groupActivityList = groupActivityList;
exports.groupActivityPass = groupActivityPass;
exports.groupActivityRefuse = groupActivityRefuse;
exports.groupRecordCount = groupRecordCount;
exports.groupRecordInfo = groupRecordInfo;
exports.groupRecordList = groupRecordList;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// ------------------------拼团活动----------------------------------------

/**
 * 分页列表
 * @param
 */
function groupActivityList(pram) {
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/activity/list',
    method: 'get',
    params: pram
  });
}
/**
 * 详情
 * @param
 */
function groupActivityInfo(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: "/admin/platform/groupbuy/activity/info",
    method: 'get',
    params: data
  });
}
/**
 * 拼团头部
 * @param
 */
function groupActivityCount(data) {
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/activity/list/count',
    method: 'get',
    params: data
  });
}
/**
 * 强制关闭
 * @param
 */
function groupActivityClose(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/activity/review/close',
    method: 'get',
    params: data
  });
}
/**
 * 审核通过
 * @param
 */
function groupActivityPass(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/activity/review/pass',
    method: 'get',
    params: data
  });
}

/**
 * 审核拒绝
 * @param
 */
function groupActivityRefuse(pram) {
  var data = {
    id: pram.id,
    reason: pram.reason
  };
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/activity/review/refuse',
    method: 'get',
    params: data
  });
}
// ------------------------拼团记录----------------------------------------
/**
 * 分页列表
 * @param
 */
function groupRecordList(pram) {
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/record/list',
    method: 'get',
    params: pram
  });
}
/**
 * 头部
 * @param
 */
function groupRecordCount(data) {
  return (0, _request.default)({
    url: '/admin/platform/groupbuy/record/list/count',
    method: 'get',
    params: data
  });
}
/**
 * 详情
 * @param
 */
function groupRecordInfo(id) {
  return (0, _request.default)({
    url: "/admin/platform/groupbuy/record/info/".concat(id),
    method: 'get'
  });
}